/**
 * PDC Month Wise Table Component
 * Displays month-wise post-dated cheque details
 */
import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import LoadingComponent from '../../loadingComponent';

export class PDCMonthWiseTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pdcData: [],
            isLoading: false
        };
    }

    componentDidMount() {
        this.processPDCData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.pdcData !== this.props.pdcData) {
            this.processPDCData();
        }
    }

    processPDCData() {
        const { pdcData } = this.props;
        // Process PDC data here when API integration is ready
        this.setState({
            pdcData: pdcData || [],
            isLoading: false
        });
    }

    formatCurrency = (value) => {
        if (!value) return '₹0.00';
        return `₹${parseFloat(value).toFixed(2)}`;
    };

    formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = date.toLocaleString('en-US', { month: 'short' });
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    };

    // Column body templates
    monthNameBodyTemplate = (rowData) => {
        return <span>{rowData.monthName || 'N/A'}</span>;
    };

    installmentNameBodyTemplate = (rowData) => {
        return <span>{rowData.installmentName || 'N/A'}</span>;
    };

    amountBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.amount)}</span>;
    };

    concessionBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.concession)}</span>;
    };

    paidAmountBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.paidAmount)}</span>;
    };

    balanceBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.balance)}</span>;
    };

    fineAmountBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.fineAmount)}</span>;
    };

    chequeNoBodyTemplate = (rowData) => {
        return <span>{rowData.chequeNo || 'N/A'}</span>;
    };

    chequeDateBodyTemplate = (rowData) => {
        return <span>{this.formatDate(rowData.chequeDate)}</span>;
    };

    micrCodeBodyTemplate = (rowData) => {
        return <span>{rowData.micrCode || 'N/A'}</span>;
    };

    bankNameBodyTemplate = (rowData) => {
        return <span>{rowData.bankName || 'N/A'}</span>;
    };

    bankBranchBodyTemplate = (rowData) => {
        return <span>{rowData.bankBranch || 'N/A'}</span>;
    };

    statusBodyTemplate = (rowData) => {
        const status = rowData.status || 'Pending';
        const statusClass = status === 'Cleared' ? 'status-cleared' : 'status-pending';
        return <span className={statusClass}>{status}</span>;
    };

    actionBodyTemplate = (rowData) => {
        return (
            <div className="action-buttons" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Button
                    icon="pi pi-eye"
                    className="p-button-rounded p-button-text"
                    tooltip="View"
                    tooltipOptions={{ position: 'top' }}
                    style={{ color: '#076EFF' }}
                    onClick={() => {
                        if (this.props.onViewDetails) {
                            this.props.onViewDetails(rowData);
                        }
                    }}
                />
            </div>
        );
    };

    render() {
        const { pdcData, isLoading } = this.state;

        return (
            <div className="pdc-month-wise-table-container">
                {isLoading && <LoadingComponent />}

                {!isLoading && (
                    <div className="pdc-table-wrapper">
                        <DataTable
                            value={pdcData}
                            scrollable
                            scrollHeight="flex"
                            className="pdc-table"
                            showGridlines
                            emptyMessage="No records to display !!!"
                        >
                            <Column
                                header="Month Name"
                                body={this.monthNameBodyTemplate}
                                style={{ width: '150px', minWidth: '150px' }}
                            />
                            <Column
                                header="Installment Name"
                                body={this.installmentNameBodyTemplate}
                                style={{ width: '180px', minWidth: '180px' }}
                            />
                            <Column
                                header="Amount"
                                body={this.amountBodyTemplate}
                                style={{ width: '130px', minWidth: '130px', textAlign: 'right' }}
                            />
                            <Column
                                header="Concession"
                                body={this.concessionBodyTemplate}
                                style={{ width: '130px', minWidth: '130px', textAlign: 'right' }}
                            />
                            <Column
                                header="Paid Amount"
                                body={this.paidAmountBodyTemplate}
                                style={{ width: '140px', minWidth: '140px', textAlign: 'right' }}
                            />
                            <Column
                                header="Balance"
                                body={this.balanceBodyTemplate}
                                style={{ width: '130px', minWidth: '130px', textAlign: 'right' }}
                            />
                            <Column
                                header="Fine Amount"
                                body={this.fineAmountBodyTemplate}
                                style={{ width: '140px', minWidth: '140px', textAlign: 'right' }}
                            />
                            <Column
                                header="Cheque No"
                                body={this.chequeNoBodyTemplate}
                                style={{ width: '150px', minWidth: '150px' }}
                            />
                            <Column
                                header="Cheque Date"
                                body={this.chequeDateBodyTemplate}
                                style={{ width: '140px', minWidth: '140px' }}
                            />
                            <Column
                                header="MICR Code"
                                body={this.micrCodeBodyTemplate}
                                style={{ width: '140px', minWidth: '140px' }}
                            />
                            <Column
                                header="Bank Name"
                                body={this.bankNameBodyTemplate}
                                style={{ width: '150px', minWidth: '150px' }}
                            />
                            <Column
                                header="Bank Branch"
                                body={this.bankBranchBodyTemplate}
                                style={{ width: '150px', minWidth: '150px' }}
                            />
                            <Column
                                header="Status"
                                body={this.statusBodyTemplate}
                                style={{ width: '120px', minWidth: '120px' }}
                            />
                            <Column
                                header="Action"
                                body={this.actionBodyTemplate}
                                style={{ width: '100px', minWidth: '100px', textAlign: 'center' }}
                            />
                        </DataTable>
                    </div>
                )}
            </div>
        );
    }
}
